import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, CircularProgress, Select, MenuItem, FormControl, InputLabel } from '@mui/material'; // 🛑 Add CircularProgress
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../../axiosInstance';
import Profile from '../../components/Profile';
import Notification from '../../components/Notification';
import Input from '../../components/ui/Input';
import { FaSearch } from "react-icons/fa";

const EditUserPage = () => {
  const { userId } = useParams();
    const [users, setUsers] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [collegeId, setCollegeId] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    mobile: '',
    displayname: '',
    role: '',
  });
  const [loading, setLoading] = useState(true); // 🛑 Add loading state
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`https://backend.scholarkart.in/api/users/${userId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setFormData(res.data);
      } catch (err) {
        console.error('Error fetching user:', err);
        if (err.response?.status === 401 || err.response?.data?.message?.includes('jwt expired')) {
          localStorage.removeItem('token');
          navigate('/LoginPage');
        } else {
          setError('Failed to load user details.');
        }
      } finally {
        setLoading(false); // 🛑 Set loading false after request
      }
    };
    fetchUser();
  }, [userId, token, navigate]);

    const fetchUsers = async () => {
      try {
        const res = await axios.get('https://backend.scholarkart.in/api/college-users');
        setUsers(res.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    
    useEffect(() => {
      fetchUsers();
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        setCollegeId(user.collegeId);
      }
    }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`https://backend.scholarkart.in/api/users/${userId}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate('/usermanagement');
    } catch (err) {
      console.error('Error updating user:', err);
    }
  };

  if (loading) {
    return (
      <Box p={4} textAlign="center">
        <CircularProgress />
        <Typography variant="body2" mt={2}>Loading user details...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={4} textAlign="center">
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <main className="flex-grow p-1">
    <div className="flex justify-between items-center relative bg-white p-4 rounded-lg shadow-md">
      {collegeId && (
        <div className="relative w-full max-w-lg">

        </div>
      )}
      <div className="flex items-center space-x-4 relative">
        <Notification />
        <Profile />
      </div>
    </div>

    <Box p={4}>
      <Typography variant="h4" mb={4}>Edit User</Typography>
      <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '1rem' }}>
        <TextField name="username" label="Username" value={formData.username} onChange={handleChange} required />
        <TextField name="email" label="Email" value={formData.email} onChange={handleChange} required />
        <TextField name="mobile" label="Mobile" value={formData.mobile} onChange={handleChange} />
        <TextField name="displayname" label="Display Name" value={formData.displayname} onChange={handleChange} />
        <FormControl fullWidth required>
          <InputLabel id="role-label">Role</InputLabel>
          <Select
            labelId="role-label"
            name="role"
            value={formData.role}
            label="Role"
            onChange={handleChange}
          >
            <MenuItem value="Student">Student</MenuItem>
            <MenuItem value="Faculty">Faculty</MenuItem>
            <MenuItem value="Librarian">Librarian</MenuItem>
          </Select>
        </FormControl>
        <Button type="submit" variant="contained" color="primary">Update User</Button>
      </form>
    </Box>
    </main>
  );
};

export default EditUserPage;
